<template>
  <div>
    <BootstrapModal
      v-if="showModal"
      :vertical-center="true"
      :content-classes="['modal__content--square-corners', 'modal__content--bg-transparent']"
      @modal-close="handleDeclineClick"
    >
      <template v-slot:body>
        <div class="bounce-preventor-modal__body text-center">
          <div class="bounce-preventor-modal__body-content">
            <div class="bounce-preventor-modal__body-content-head">
              Your Memories May Not Be Available Much Longer!
            </div>
            <div class="bounce-preventor-modal__body-content-subhead">
              Save Them Now Before They're Gone!
            </div>
            <div>
              <a
                class="button button--cta bounce-preventor-modal__body-content-cta"
                href="#"
                @click.prevent="handleCtaClick"
              >
                Secure My Photos
              </a>
            </div>
            <div>
              <a
                class="bounce-preventor-modal__body-content-decline-link"
                href="#"
                @click.prevent="handleDeclineClick"
              >
                No Thanks
              </a>
            </div>
          </div>
        </div>
      </template>
    </BootstrapModal>
  </div>
</template>

<script>
import exitIntent from 'exit-intent'

import BootstrapModal from '@/shared/components/BootstrapModal.vue'
import ga4 from '@/shared/lib/google-analytics-v4'

const bouncePreventorDeclinedStorageKey = 'mf_bp_declined'

export default {
  name: 'BouncePreventor',
  components: { BootstrapModal },
  props: {
    secondsUntilActive: { type: Number, default: 10, required: false },
    ctaUrl: { type: String, default: null, required: true }
  },
  data () {
    return {
      exitIntentInstance: null,
      showModal: false
    }
  },
  created () {
    setTimeout(() => {
      this.exitIntentInstance = exitIntent({
        threshold: 5,
        maxDisplays: 2,
        eventThrottle: 50,
        onExitIntent: () => {
          this.handleExitIntent()
        }
      })
    }, (this.secondsUntilActive * 1000))
  },
  methods: {
    handleExitIntent () {
      const bouncePreventorDeclined = window.sessionStorage.getItem(bouncePreventorDeclinedStorageKey) !== null

      if (!bouncePreventorDeclined) {
        ga4.trackEvent('bounce_preventor_open')
        this.showModal = true
      }
    },
    handleCtaClick () {
      ga4.trackEvent('bounce_preventor_user_clicked_cta', { url: this.ctaUrl })
      window.location.href = this.ctaUrl
    },
    handleDeclineClick () {
      ga4.trackEvent('bounce_preventor_user_declined')
      window.sessionStorage.setItem(bouncePreventorDeclinedStorageKey, Date.now())
      this.showModal = false
      this.destroyExitIntentInstance()
    },
    destroyExitIntentInstance () {
      this.exitIntentInstance() // calling instance as fn destroys it
    }
  }
}
</script>

<style lang="scss" scoped>
.bounce-preventor-modal {
  &__body {
    background: transparent url('./assets/modal-header.png') no-repeat center top;
    padding: 211px 0 0 0;

    &-content {
      background-color: #f8f9fa; // matches the background color of the modal header image
      padding-bottom: 3rem;

      &-head {
        font-weight: 800;
        font-size: 2.2rem;
        line-height: 3.2rem;
        margin-bottom: 1.6rem;
      }

      &-subhead {
        font-weight: 600;
        font-size: 1.6rem;
        line-height: 2.6rem;
        margin-bottom: 1.6rem;
      }

      &-cta {
        font-size: 1.6rem;
        font-weight: normal;
        height: auto;
        line-height: 2.6rem;
        margin: 0 0 2rem 0;
        padding: 1rem 2rem;
        text-align: center !important;
      }

      &-decline-link {
        color: #000;
        text-decoration: underline;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/BouncePreventor/BouncePreventor.vue